import { getTranslationResult, loopArr, replaceVars } from "./translate";

// interface OptionsBaseType {
//   returnObjects?: boolean;
// }
//
// interface StringMap {
//   [key: string]: string | boolean;
// }
// type OptionsType = OptionsBaseType & StringMap;
interface OptionsType {
  returnObjects?: boolean;
  [key: string]: string | number | boolean | undefined;
}

// TODO: this is a mock of real translation function. When i18n is needed, it should be replace this.
export function useAppTranslation() {
  return {
    t: (tKey: string, allOptions: OptionsType = {}): any => {
      const { returnObjects = false, ...options } = allOptions;
      if (returnObjects) {
        const arrResult = loopArr(getTranslationResult(tKey), options);
        return arrResult;
      }
      const result = replaceVars(getTranslationResult(tKey)?.toString(), options);
      return result;
    },
  };
}
